import Vue from 'vue';
import VueRouter from 'vue-router';
import Content from '../views/Content';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Content
  },
  {
    path: '/:slug',
    name: 'Home',
    component: Content
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
